var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgToxicityIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6812 14.4165L12.0367 1.17586C11.6116 0.439609 10.8502 0 9.99999 0C9.1498 0 8.38839 0.439609 7.96331 1.17586L0.318837 14.4165C-0.106279 15.1528 -0.106279 16.032 0.318837 16.7682C0.743954 17.5045 1.50528 17.9441 2.35551 17.9441H17.6445C18.4947 17.9441 19.256 17.5045 19.6812 16.7683C20.1063 16.032 20.1063 15.1528 19.6812 14.4165ZM18.6664 16.1824C18.4531 16.5519 18.0711 16.7724 17.6445 16.7724H2.35551C1.92887 16.7724 1.54684 16.5519 1.33356 16.1824C1.12028 15.813 1.12028 15.3719 1.33356 15.0024L8.97812 1.76175C9.1914 1.3923 9.57343 1.17176 10 1.17176C10.4266 1.17176 10.8087 1.3923 11.0219 1.76175L18.6665 15.0024C18.8797 15.3719 18.8797 15.813 18.6664 16.1824Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5858 5.84717H9.41412V11.7058H10.5858V5.84717Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12.8777C9.56927 12.8777 9.21884 13.2281 9.21884 13.6589C9.21884 14.0896 9.56927 14.44 10 14.44C10.4307 14.44 10.7812 14.0896 10.7812 13.6589C10.7812 13.2281 10.4308 12.8777 10 12.8777Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgToxicityIcon);
export default __webpack_public_path__ + "static/media/ToxicityIcon.bfe6df34.svg";
export { ForwardRef as ReactComponent };